/* eslint-disable sonarjs/no-duplicate-string */
import { AnalyticsProviders, Provider, DefaultProviders } from './models/Event';
import { brazeCustomUserAttributeFn, ga4LogoutFtn, getGa4PredefinedFn, getBrazePredefinedFn, brazeLogPurchase, getMParticleAuthFn, mParticleLogCommerceEventProduct, mParticleLogCommerceEventPromotion, ga4SetUserId, mParticleLogCommerceEventImpression, fsLogOrderCompleted, } from './models/DataFunctions';
const { GTMProvider, GA4Provider, BrazeProvider, EnhancedBrazeProvider, MParticleProvider, BranchProvider, } = DefaultProviders;
const { GA4, Braze, MParticle, FullStory } = AnalyticsProviders;
const { provider } = Provider;
const CONST_CURRENCY = '%currency%';
const CONST_ITEM_LIST_NAME = '%item_list_name%';
const events = {
    appLaunch: {
        name: 'appLaunch',
        payload: [
            {
                data: {
                    item_clicked: 'Product (%productname%) Card clicked',
                },
            },
        ],
    },
    view_promotion: {
        name: 'view_promotion',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider],
                data: {
                    promotion_name: '%promotion_name%',
                    promotion_id: '%promotion_id%',
                    creative_name: '%creative_name%',
                    location_id: '%location_id%',
                    items: '%items%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, provider(MParticle, [mParticleLogCommerceEventPromotion])],
                data: {
                    promotion_action_type: '%promotion_action_type%',
                    promotion_name: '%promotion_name%',
                    promotion_id: '%promotion_id%',
                    location_id: '%location_id%',
                    creative_name: '%creative_name%',
                },
            },
        ],
    },
    navigationLinkClick: {
        name: 'navigationLinkClick',
        payload: [
            {
                providers: [GA4Provider],
                data: { navigationLink: '%navigationLink%' },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    navigationLink: '%navigationLink%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    viewOfferDetails: {
        name: 'viewOfferDetails',
        payload: [
            {
                providers: [GA4Provider],
                data: { offerName: '%titleValue%' },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    offerName: '%titleValue%',
                    user_type: '%userType%',
                    promo_type: '%promoType%',
                    disposition: '%disposition%',
                },
            },
        ],
    },
    redeemOffer: {
        name: 'redeemOffer',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider],
                data: { offerName: '%titleValue%' },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    offerName: '%titleValue%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    selectOrderType: {
        name: 'selectOrderType',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    disposition: '%disposition%',
                    userType: '%userType%',
                },
            },
            {
                providers: [GA4Provider],
                data: { orderType: '%OrderType%' },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    orderType: '%OrderType%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    homepageBannerCTA: {
        name: 'homepageBannerCTA',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    index: '%index%',
                    content: '%content%',
                },
            },
            {
                providers: [GTMProvider],
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: { index: '%index%', content: '%content%', eventType: '%eventType%' },
            },
        ],
    },
    // to be deleted for pwa
    homepageBannerClickToAction: {
        name: 'homepageBannerCTA',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    footerClick: {
        name: 'footerClick',
        payload: [
            {
                providers: [GA4Provider, EnhancedBrazeProvider],
                data: { footerClickType: '%footerClickType%' },
            },
        ],
    },
    guestCheckout: {
        name: 'guestCheckout',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    name: '%name%',
                    phone: '%phone%',
                    email: '%email%',
                    marketing_opt_in: '%marketing_opt_in%',
                },
            },
        ],
    },
    beginCheckout: {
        name: 'beginCheckout',
        payload: [
            {
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    coupons: '%coupon%',
                    items: '%items%',
                },
            },
        ],
    },
    logBeginCheckout: {
        name: 'logBeginCheckout',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logBeginCheckout')])],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    coupon: '%coupon%',
                    items: '%items%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    currency: CONST_CURRENCY,
                    product_action_type: '%product_action_type%',
                    items: '%items%',
                    revenue: '%value%',
                    couponCode: '%couponCode%',
                    checkout_step: '%checkout_step%',
                    discount: '%discount%',
                    shippingTier: '%service%',
                    commerceEventType: '%commerce_event_type%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'logBeginCheckout',
                data: {
                    userType: '%userType%',
                    disposition: '%disposition%',
                    timestamp: '%timestamp%',
                    store_id: '%store_id%',
                    items: '%items%',
                    value: '%value%',
                    coupon: '%coupon%',
                    discount: '%discount%',
                    currency: '%currency%',
                    buos: (branch, params) => {
                        const items = params?.['items'] || [];
                        const buos = items?.map(async (item) => {
                            const options = {
                                locallyIndex: true,
                                title: item.item_name,
                                contentDescription: item.item_list_name,
                                contentMetadata: {
                                    productName: item.item_name,
                                    sku: item.item_id,
                                    quantity: item.quantity || 1,
                                    price: params?.value,
                                    productVariant: item.item_variant,
                                    customMetadata: {
                                        item_list_id: item.item_list_id || '',
                                        index: item.item_index?.toString() || '-1',
                                        currency: params?.currency,
                                        item_category: item.item_category,
                                        list_name: item.item_name,
                                        coupon: params?.coupon,
                                        discount: params?.discount,
                                    },
                                },
                            };
                            return await branch?.createBranchUniversalObject(`/products/${item.item_id}`, options);
                        });
                        return Promise.all(buos);
                    },
                    eventParams: (eventName, params) => {
                        const item = params?.['items']?.[0] || {};
                        const param = params || {};
                        return {
                            alias: `${eventName} | ${item?.item_list_name}`,
                            customData: {
                                userType: param?.userType,
                                disposition: param?.disposition,
                                timestamp: param?.timestamp,
                                store_id: param?.store_id,
                            },
                        };
                    },
                },
            },
        ],
    },
    AddContactDetails: {
        name: 'AddContactDetails',
        payload: [
            {
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    coupon: '%coupon%',
                    items: '%items%',
                },
            },
        ],
    },
    selectItem: {
        name: 'selectItem',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    item_list_id: '%item_list_id%',
                    item_list_name: CONST_ITEM_LIST_NAME,
                    content_type: '%content_type%',
                    items: '%items%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    product_action_type: '%product_action_type%',
                    item_name: '%item_name%',
                    item_sku: '%item_id%',
                    content_type: '%content_type%',
                    value: '%value%',
                    item_quantity: '%quantity%',
                    item_category: '%item_category%',
                    item_list_id: '%item_list_id%',
                    item_list_name: CONST_ITEM_LIST_NAME,
                },
            },
        ],
    },
    useMyLocation: {
        name: 'useMyLocation',
        payload: [
            {
                providers: [GTMProvider, GA4Provider],
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    checkIn: {
        name: 'checkIn',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    checkInLocation: '%checkInLocation%',
                },
            },
        ],
    },
    pickupMethod: {
        name: 'pickupMethod',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    pickupOption: '%pickupOption%',
                },
            },
        ],
    },
    upsizeSelected: {
        name: 'upsizeSelected',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    upsizeProduct: '%upsizeProduct%',
                    size: '%size%',
                    upsizeSelectedFrom: '%upsizeSelectedFrom%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    upsizeProduct: '%upsizeProduct%',
                    size: '%size%',
                    upsizeSelectedFrom: '%upsizeSelectedFrom%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    viewHomePageOffer: {
        name: 'viewHomePageOffer',
        payload: [
            {
                providers: [GA4Provider],
            },
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    addPaymentInfo: {
        name: 'addPaymentInfo',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logAddPaymentInfo')])],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    coupon: '%coupon%',
                    payment_type: '%payment_type%',
                    items: '%items%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    currency: CONST_CURRENCY,
                    product_action_type: '%product_action_type%',
                    items: '%items%',
                    revenue: '%value%',
                    payment_type: '%payment_type%',
                    couponCode: '%couponCode%',
                    checkout_step: '%checkout_step%',
                    discount: '%discount%',
                    commerceEventType: '%commerce_event_type%',
                },
            },
        ],
    },
    logout: {
        name: 'logout',
        payload: [
            {
                providers: [provider(GA4, [ga4LogoutFtn])],
            },
            {
                providers: [provider(MParticle, [getMParticleAuthFn('logout')])],
            },
        ],
    },
    localisationView: {
        name: 'localisationView',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider],
                data: {
                    viewType: '%viewType%',
                    orderType: '%orderType%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    viewType: '%viewType%',
                    orderType: '%orderType%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    subscribeToLoyalty: {
        name: 'subscribeToLoyalty',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
            },
        ],
    },
    add_to_cart: {
        name: 'add_to_cart',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [BrazeProvider, EnhancedBrazeProvider],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    item_id: '%item_id%',
                    item_name: '%item_name%',
                    item_category: '%item_category%',
                    item_list_name: '%item_list_name%',
                    item_quantity: '%quantity%',
                },
            },
        ],
    },
    logAddToCart: {
        name: 'logAddToCart',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logAddToCart')])],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    items: '%items%',
                },
            },
            {
                providers: [BrazeProvider],
                eventName: 'add_to_cart',
                data: {
                    items: '%brazeItems%',
                },
            },
            {
                providers: [provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    currency: CONST_CURRENCY,
                    product_action_type: '%product_action_type%',
                    item_name: '%item_name%',
                    item_sku: '%item_id%',
                    item_list_name: CONST_ITEM_LIST_NAME,
                    item_category: '%item_category%',
                    value: '%value%',
                    item_quantity: '%quantity%',
                    affiliation: '%affiliation%',
                    couponCode: '%couponCode%',
                    shipping: '%shipping%',
                    discount: '%discount%',
                    tax: '%tax%',
                    revenue: '%revenue%',
                    custom_attributes: '%custom_attributes%',
                    index: '%index%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'AddToCart',
                data: {
                    currency: CONST_CURRENCY,
                    price: '%value%',
                    items: '%items%',
                    buos: (branch, params) => {
                        const items = params?.['items'] || [];
                        const buos = items.map(async (item) => {
                            const options = {
                                locallyIndex: true,
                                title: item.item_name,
                                contentDescription: item.item_list_name,
                                contentMetadata: {
                                    price: params?.['price'],
                                    currency: params?.['currency'],
                                    sku: item.item_id,
                                    productName: item.item_name,
                                    // productCategory: item.item_category,
                                    productVariant: item.item_variant,
                                    quantity: item.quantity || 1,
                                    customMetadata: {
                                        item_list_id: item.item_list_id || '',
                                        index: item.item_index?.toString() || '-1',
                                    },
                                },
                            };
                            return await branch?.createBranchUniversalObject(`/products/${item.item_id}`, options);
                        });
                        return Promise.all(buos);
                    },
                    eventParams: (eventName, params) => {
                        const item = params?.['items']?.[0] || {};
                        return {
                            alias: `${eventName} | ${item.item_list_name}`,
                        };
                    },
                },
            },
        ],
    },
    logViewItemList: {
        name: 'logViewItemList',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logViewItemList')])],
                data: {
                    item_list_name: CONST_ITEM_LIST_NAME,
                    items: '%items%',
                },
            },
        ],
    },
    productImpressionsEvent: {
        name: 'productImpressionsEvent',
        payload: [
            {
                providers: [provider(MParticle, [mParticleLogCommerceEventImpression])],
                data: {
                    item_list_name: '%item_list_name%',
                    item_name: '%item_name%',
                    quantity: '%quantity%',
                    item_category: '%item_category%',
                    item_sku: '%item_id%',
                    value: '%price%',
                },
            },
        ],
    },
    logCommerceEvent: {
        name: 'logCommerceEvent',
        payload: [
            {
                providers: [provider(MParticle, [mParticleLogCommerceEventImpression])],
                data: {
                    item_list_name: '%item_list_name%',
                    item_name: '%item_name%',
                    quantity: '%quantity%',
                    item_category: '%item_category%',
                    price: '%price%',
                    item_sku: '%item_id%',
                    value: '%value%',
                    item_quantity: '%item_quantity%',
                    currency: '%currency%',
                },
            },
        ],
    },
    virtualPageView: {
        name: 'virtualPageView',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    pageUrl: '%pageUrl%',
                    pageTitle: 'KFC India - %pageTitle%',
                },
            },
        ],
    },
    customDimension: {
        name: 'customDimension',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    collectionPoint: '%collectionPoint%',
                    disposition: '%disposition%',
                    loggedIn: '%loggedIn%',
                    postLocalisation: '%postLocalisation%',
                    storeID: '%storeID%',
                    userID: '%userID%',
                    platform: '%platform%',
                },
            },
        ],
    },
    startOrder: {
        name: 'startOrder',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [GA4Provider],
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    cancelOrder: {
        name: 'cancelOrder',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [GA4Provider],
            },
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    disposition: '%disposition%',
                    transaction_id: '%transactionId%',
                },
            },
        ],
    },
    addDeliveryInfo: {
        name: 'addDeliveryInfo',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    disposition: '%disposition%',
                    userType: '%userType%',
                },
            },
        ],
    },
    keepOrder: {
        name: 'keepOrder',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    keepOrder: '%keepOrder%',
                },
            },
        ],
    },
    openSecretMenu: {
        name: 'openSecretMenu',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    keepOrder: '%keepOrder%',
                },
            },
        ],
    },
    localisationStart: {
        name: 'localisationStart',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [GA4Provider],
            },
            {
                providers: [BrazeProvider, EnhancedBrazeProvider],
            },
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'localisationStart',
            },
        ],
    },
    orderNow: {
        name: 'orderNow',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [GA4Provider],
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    orderForLater: {
        name: 'orderForLater',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    signUpStart: {
        name: 'signUpStart',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
            },
            {
                providers: [GA4Provider],
            },
        ],
    },
    signInStart: {
        name: 'signInStart',
        payload: [
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    event: '%event%',
                    loginMethod: '%loginMethod%',
                },
            },
            {
                providers: [GTMProvider],
                eventName: 'loginStart',
                data: {
                    event: '%event%',
                    loginMethod: '%loginMethod%',
                },
            },
        ],
    },
    registrationStart: {
        name: 'registrationStart',
        payload: [
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    loginStart: {
        name: 'loginStart',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    loginMethodClicked: '%loginMethodClicked%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    registrationComplete: {
        name: 'registrationComplete',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    userID: '%userID%',
                    email: '%email%',
                    loginMethod: '%loginMethod%',
                    firstName: '%firstName%',
                    lastName: '%lastName%',
                    phone: '%phone%',
                },
            },
        ],
    },
    registrationFinish: {
        name: 'registrationFinish',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    userID: '%userID%',
                    emailAddress: '%emailAddress%',
                    loginMethod: '%loginMethod%',
                    firstName: '%firstName%',
                    lastName: '%lastName%',
                    phoneNumber: '%phoneNumber%',
                    postCode: '%postCode%',
                    marketingEmails: '%marketingEmails%',
                    receiveSMS: '%receiveSMS%',
                },
            },
            {
                providers: [GA4Provider],
                data: {
                    userID: '%userID%',
                    loginMethod: '%loginMethod%',
                },
            },
            {
                providers: [MParticleProvider],
                data: {
                    loginMethod: '%loginMethod%',
                    eventType: '%eventType%',
                    userID: '%userID%',
                    emailId: '%emailId%',
                    phoneNumber: '%phoneNumber%',
                    postCode: '%postalCode%',
                    marketingEmails: '%marketingEmail%',
                    marketingPhone: '%marketingPhone%',
                    firstName: '%firstName%',
                    lastName: '%lastName%',
                },
            },
            {
                providers: [BrazeProvider, EnhancedBrazeProvider],
                data: {
                    loginMethod: '%loginMethod%',
                    user_id: '%userID%',
                    emailAddress: '%emailId%',
                    phoneNumber: '%phoneNumber%',
                    postCode: '%postalCode%',
                    marketingEmails: '%marketingEmail%',
                    marketingPhone: '%marketingPhone%',
                    firstName: '%firstName%',
                    lastName: '%lastName%',
                },
            },
        ],
    },
    completeRegistration: {
        name: 'completeRegistration',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    loginMethod: '%loginMethod%',
                    userID: '%userID%',
                    eventType: '%eventType%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'CompleteRegistration',
                data: {
                    userID: '%userID%',
                    loginMethod: '%loginMethod%',
                    eventParams: (eventName, params) => {
                        return {
                            alias: `${eventName}_FINISH | Sign Up`,
                            customData: {
                                userID: params.userID,
                                loginMethod: params.loginMethod,
                            },
                        };
                    },
                },
            },
        ],
    },
    checkoutClick: {
        name: 'checkoutClick',
        payload: [
            {
                providers: [GTMProvider, GA4Provider, EnhancedBrazeProvider],
            },
        ],
    },
    setUserId: {
        name: 'setUserId',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('setUserId')])],
            },
        ],
    },
    gaSetUserId: {
        name: 'gaSetUserId',
        payload: [
            {
                providers: [provider(GA4, [ga4SetUserId])],
                data: {
                    userId: '%userId%',
                },
            },
        ],
    },
    changeUser: {
        name: 'changeUser',
        payload: [
            {
                providers: [provider(GA4, [ga4SetUserId])],
                data: {
                    userId: '%userId%',
                },
            },
            {
                providers: [provider(Braze, [getBrazePredefinedFn('changeUser')])],
                data: {
                    userId: '%userId%',
                    userAttributes: '%userAttributes%',
                },
            },
            {
                providers: [provider(MParticle, [getMParticleAuthFn('login')])],
                data: {
                    email: '%email%',
                    customerId: '%customerId%',
                    userAttributes: '%userAttributes%',
                },
            },
        ],
    },
    setFirstName: {
        name: 'setFirstName',
        payload: [
            {
                providers: [new Provider(Braze, [getBrazePredefinedFn('setFirstName')])],
                data: {
                    firstName: '%firstName%',
                },
            },
        ],
    },
    setLastName: {
        name: 'setLastName',
        payload: [
            {
                providers: [new Provider(Braze, [getBrazePredefinedFn('setLastName')])],
                data: {
                    lastName: '%lastName%',
                },
            },
        ],
    },
    setEmail: {
        name: 'setEmail',
        payload: [
            {
                providers: [new Provider(Braze, [getBrazePredefinedFn('setEmail')])],
                data: {
                    email: '%email%',
                },
            },
        ],
    },
    setPhoneNumber: {
        name: 'setPhoneNumber',
        payload: [
            {
                providers: [new Provider(Braze, [getBrazePredefinedFn('setPhoneNumber')])],
                data: {
                    phoneNumber: '%phoneNumber%',
                },
            },
        ],
    },
    loginMethod: {
        name: 'loginMethod',
        payload: [
            {
                providers: [provider(Braze, [brazeCustomUserAttributeFn])],
                data: {
                    loginMethod: '%loginMethod%',
                },
            },
        ],
    },
    logPurchase: {
        name: 'logPurchase',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    transaction_id: '%transactionId%',
                    value: '%value%',
                    currency: CONST_CURRENCY,
                    tax: '%tax%',
                    coupon: '%coupon%',
                    shipping: '%shipping%',
                    items: '%items%',
                    bottle_deposit: '%bottle_deposit%',
                    tip_selection: '%tip_selection%',
                    tip_amount: '%tip_amount%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, provider(Braze, [brazeLogPurchase])],
                data: {
                    currency: CONST_CURRENCY,
                    products: '%products%',
                },
                userAttributeFn: brazeCustomUserAttributeFn,
                userAttributes: {
                    store_id: '%store_id%',
                    first_purchase: '%first_purchase%',
                    total_purchase: '%total_purchase%',
                    store_city: '%store_city%',
                    last_purchase: '%last_purchase%',
                },
            },
            {
                providers: [provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    currency: CONST_CURRENCY,
                    product_action_type: '%product_action_type%',
                    items: '%items%',
                    revenue: '%value%',
                    tax: '%tax%',
                    shipping: '%shipping%',
                    discount: '%discount%',
                    transaction_id: '%transactionId%',
                    couponCode: '%couponCode%',
                    bottle_deposit: '%bottle_deposit%',
                    tip_selection: '%tip_selection%',
                    tip_amount: '%tip_amount%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'Purchase',
                data: {
                    currency: CONST_CURRENCY,
                    items: '%items%',
                    revenue: '%value%',
                    shipping: '%shipping%',
                    tax: '%tax%',
                    coupon: '%coupon%',
                    transactionID: '%transactionId%',
                    buos: (branch, params) => {
                        const items = params?.['items'] || [];
                        const buos = items.map(async (item) => {
                            const options = {
                                locallyIndex: true,
                                title: item.item_name,
                                contentDescription: item.item_list_name,
                                contentMetadata: {
                                    sku: item.item_id,
                                    productName: item.item_name,
                                    // productCategory: item.item_category,
                                    quantity: item.quantity,
                                },
                            };
                            return await branch?.createBranchUniversalObject(`/products/${item.item_id}`, options);
                        });
                        return Promise.all(buos);
                    },
                    eventParams: (eventName, params) => {
                        const item = params?.['items']?.[0] || {};
                        return {
                            alias: `${eventName} | ${item.item_list_name}`,
                            revenue: params?.['revenue'],
                            shipping: params?.['shipping'],
                            tax: params?.['tax'],
                            currency: params?.['currency'],
                            coupon: params?.['coupon'],
                            transactionID: params?.['transactionID'],
                        };
                    },
                },
            },
        ],
    },
    editPersonalInformation: {
        name: 'editPersonalInformation',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    firstName: '%firstName%',
                    lastName: '%lastName%',
                    email: '%email%',
                    phone: '%phone%',
                },
            },
            {
                providers: [GA4Provider],
            },
        ],
    },
    updateCommunicationPreferences: {
        name: 'updateCommunicationPreferences',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    marketingEmails: '%marketingEmails%',
                    editorAndCustomerFavourites: '%editorAndCustomerFavourites%',
                    newsAndAnnouncements: '%newsAndAnnouncements%',
                    doNotSellInformation: '%doNotSellInformation%',
                    receiveSMS: '%receiveSMS%',
                },
            },
            {
                providers: [BrazeProvider, EnhancedBrazeProvider],
                userAttributeFn: brazeCustomUserAttributeFn,
                userAttributes: {
                    marketing_emails: '%marketing_emails%',
                    editor_customer_favourites: '%editor_customer_favourites%',
                    news_announcements: '%news_announcements%',
                    do_not_sell_info: '%do_not_sell_info%',
                    receive_sms: '%receive_sms%',
                },
            },
            {
                providers: [MParticleProvider],
                data: {
                    marketingEmails: '%marketing_emails%',
                    receiveSMS: '%receive_sms%',
                    editorAndCustomerFavourites: '%editor_customer_favourites%',
                    newsAndAnnouncements: '%news_announcements%',
                    eventType: '%event_type%',
                    doNotSellInformation: '%do_not_sell_info%',
                },
            },
        ],
    },
    signOutSuccess: {
        name: 'signOutSuccess',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    userID: '%userID%',
                },
            },
            {
                providers: [GA4Provider],
                data: {
                    userID: '%userID%',
                },
            },
        ],
    },
    localisationSignIn: {
        name: 'localisationSignIn',
        payload: [
            {
                providers: [GTMProvider, GA4Provider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    deleteAccount: {
        name: 'deleteAccount',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    userID: '%userID%',
                },
            },
            {
                providers: [GA4Provider],
                data: {
                    userID: '%userID%',
                },
            },
        ],
    },
    viewItem: {
        name: 'viewItem',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    ecommerce: {
                        view_item: {
                            items: [
                                {
                                    item_name: '%item_name%',
                                    item_id: '%item_id%',
                                    price: '%price%',
                                    item_category: '%item_category%',
                                    item_list_name: CONST_ITEM_LIST_NAME,
                                    item_list_id: '%item_list_id%',
                                    index: '%index%',
                                    quantity: '%quantity%',
                                },
                            ],
                        },
                    },
                },
            },
        ],
    },
    upsizeSelectedPwa: {
        name: 'upsizeSelectedPwa',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    upsizeProduct: '%upsizeProduct%',
                    size: '%size%',
                    upsizeSelectedFrom: '%upsizeSelectedFrom%',
                },
            },
        ],
    },
    addToCart: {
        name: 'addToCart',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    ecommerce: {
                        add_to_cart: {
                            items: [
                                {
                                    item_name: '%item_name%',
                                    item_id: '%item_id%',
                                    item_tag: '%item_tag%',
                                    price: '%price%',
                                    item_variant: '%item_variant%',
                                    item_list_name: CONST_ITEM_LIST_NAME,
                                    item_list_id: '%item_list_id%',
                                    index: '%index%',
                                    quantity: '%quantity%',
                                },
                            ],
                        },
                    },
                },
            },
        ],
    },
    remove_from_cart: {
        // For complex objects data is registered dynamically
        name: 'remove_from_cart',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logRemoveFromCart')])],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    items: '%items%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    currency: CONST_CURRENCY,
                    product_action_type: '%product_action_type%',
                    item_name: '%item_name%',
                    item_category: '%item_category%',
                    item_list_name: CONST_ITEM_LIST_NAME,
                    item_sku: '%item_id%',
                    value: '%value%',
                    item_quantity: '%quantity%',
                    affiliation: '%affiliation%',
                    couponCode: '%couponCode%',
                    shipping: '%shipping%',
                    tax: '%tax%',
                    revenue: '%revenue%',
                    custom_attributes: '%custom_attributes%',
                },
            },
        ],
    },
    remove_all_from_cart: {
        // For complex objects data is registered dynamically
        name: 'remove_all_from_cart',
    },
    upsizeOrder: {
        // For complex objects data is registered dynamically
        name: 'upsizeOrder',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    confirmUpsize: {
        // For complex objects data is registered dynamically
        name: 'confirmUpsize',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    editCartItem: {
        name: 'editCartItem',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [GA4Provider],
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    selectItemPwa: {
        name: 'selectItemPwa',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    ecommerce: {
                        selected_item: {
                            items: [
                                {
                                    item_name: '%item_name%',
                                    item_id: '%item_id%',
                                    item_category: '%item_category%',
                                    item_variant: '%item_variant%',
                                    item_tag: '%item_tag%',
                                    item_list_name: CONST_ITEM_LIST_NAME,
                                    item_list_id: '%item_list_id%',
                                    index: '%index%',
                                    quantity: '%quantity%',
                                    price: '%price%',
                                },
                            ],
                        },
                    },
                },
            },
        ],
    },
    makeItACombo: {
        name: 'makeItACombo',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
        ],
    },
    // For complex objects data is registered dynamically
    viewItemList: {
        name: 'viewItemList',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider, EnhancedBrazeProvider],
                data: {
                    item_list_name: CONST_ITEM_LIST_NAME,
                    items: '%items%',
                },
            },
        ],
    },
    guestContactDetails: {
        name: 'guestContactDetails',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                },
            },
            {
                providers: [GA4Provider],
            },
        ],
    },
    addContactInfo: {
        name: 'addContactInfo',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    beginCheckoutPwa: {
        name: 'beginCheckoutPwa',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    paymentInfoClick: {
        name: 'paymentInfoClick',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    purchaseOrder: {
        name: 'purchaseOrder',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
            },
        ],
    },
    signUpClick: {
        name: 'signUpClick',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    orderValue: '%orderValue%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    orderValue: '%orderValue%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    popupView: {
        name: 'popupView',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    popupTitle: '%popupTitle%',
                },
            },
        ],
    },
    findAKFC: {
        name: 'findAKFC',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                },
            },
        ],
    },
    selectItemPlp: {
        name: 'selectItemPlp',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    viewItemListPlp: {
        name: 'viewItemListPlp',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    viewAllDeals: {
        name: 'viewAllDeals',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
            },
        ],
    },
    addToCartPlp: {
        name: 'addToCartPlp',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    menuNavigation: {
        name: 'menuNavigation',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    menuNavigationLink: '%menuNavigationLink%',
                    menuIndex: '%menuIndex%',
                },
            },
        ],
    },
    topNavigationLinks: {
        name: 'topNavigationLinks',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
                data: {
                    event: '%event%',
                    navigationLink: '%navigationLink%',
                },
            },
        ],
    },
    accountViewFavItemList: {
        // For complex objects data is registered dynamically
        name: 'accountViewFavItemList',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    select_promotion: {
        name: 'select_promotion',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logSelectPromotion')])],
                data: {
                    promotion_name: '%promotion_name%',
                    promotion_id: '%promotion_id%',
                    creative_name: '%creative_name%',
                    location_id: '%location_id%',
                    creative_slot: '%creative_slot%',
                    items: '%items%',
                },
            },
            {
                providers: [GTMProvider],
            },
            {
                providers: [EnhancedBrazeProvider, provider(MParticle, [mParticleLogCommerceEventPromotion])],
                data: {
                    promotion_action_type: '%promotion_action_type%',
                    promotion_name: '%promotion_name%',
                    promotion_id: '%promotion_id%',
                    location_id: '%location_id%',
                    creative_name: '%creative_name%',
                    user_type: '%userType%',
                    promo_type: '%promoType%',
                    disposition: '%disposition%',
                },
            },
        ],
    },
    // to be deleted for pwa
    selectPromotion: {
        name: 'select_promotion',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    keepShopping: {
        name: 'keepShopping',
        payload: [
            {
                providers: [GTMProvider, GA4Provider],
            },
        ],
    },
    guestContactDetailsRna: {
        name: 'guestContactDetails',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    transactionFail: {
        name: 'transactionFail',
        payload: [
            {
                data: {
                    errorMessage: '%errorMessage%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    errorMessage: '%errorMessage%',
                },
            },
        ],
    },
    reorder: {
        name: 'reorder',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider],
                data: {
                    orderName: '%orderName%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    orderName: '%orderName%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    orderType: {
        name: 'orderType',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    footerLinks: {
        name: 'footerLinks',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    orderLater: {
        name: 'orderLater',
        payload: [
            {
                providers: [GA4Provider],
                data: {
                    disposition: '%disposition%',
                },
            },
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    disposition: '%disposition%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    disposition: '%disposition%',
                },
            },
        ],
    },
    localisationFinish: {
        name: 'localisationFinish',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    disposition: '%disposition%',
                    postLocalisation: '%postLocalisation%',
                    storeID: '%storeID%',
                    postCode: '%postCode%',
                    localisationType: '%localisationType%',
                },
            },
            {
                providers: [GA4Provider],
                data: {
                    postLocalisation: '%postLocalisation%',
                    storeID: '%storeID%',
                    disposition: '%disposition%',
                    postCode: '%postCode%',
                    localisationType: '%localisationType%',
                    eventType: '%eventType%',
                },
            },
            {
                providers: [MParticleProvider],
                data: {
                    postLocalisation: '%postLocalisation%',
                    storeID: '%storeID%',
                    disposition: '%disposition%',
                    postCode: '%postCode%',
                    eventType: '%eventType%',
                    localisationType: '%localisationType%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'localisationFinish',
                data: {
                    postLocalisation: '%postLocalisation%',
                    storeID: '%storeID%',
                    disposition: '%disposition%',
                    postCode: '%postCode%',
                    localisationType: '%localisationType%',
                    eventParams: (params) => {
                        return {
                            customData: {
                                postLocalisation: params.postLocalisation,
                                storeID: params.storeID,
                                disposition: params.disposition,
                                postCode: params.postCode,
                                localisationType: params.localisationType,
                            },
                        };
                    },
                },
            },
            {
                providers: [BrazeProvider, EnhancedBrazeProvider],
                data: {
                    postLocalisation: '%postLocalisation%',
                    storeID: '%storeID%',
                    disposition: '%disposition%',
                    postCode: '%postCode%',
                    localisationType: '%localisationType%',
                },
            },
        ],
    },
    localisationError: {
        name: 'localisationError',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
            {
                providers: [GTMProvider],
            },
        ],
    },
    changeStore: {
        name: 'changeStore',
        payload: [
            {
                providers: [GTMProvider, GA4Provider],
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    suggestedSearchClick: {
        name: 'suggestedSearchClick',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider],
                data: {
                    suggestedSearchTerm: '%suggestedSearchTerm%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    suggestedSearchTerm: '%suggestedSearchTerm%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    filterItems: {
        name: 'filterItems',
        payload: [
            {
                providers: [GTMProvider, EnhancedBrazeProvider],
            },
        ],
    },
    userSearch: {
        name: 'userSearch',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [GA4Provider],
                data: {
                    searchTerm: '%searchTerm%',
                    resultsFound: '%resultsFound%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    searchTerm: '%searchTerm%',
                    resultsFound: '%resultsFound%',
                    eventType: '%eventType%',
                },
            },
        ],
    },
    embeddedErrorMessage: {
        name: 'embeddedErrorMessage',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    popupOrPageTitle: '%popupOrPageTitle%',
                    errorMessage: '%errorMessage%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    popupTitle: '%popupOrPageTitle%',
                    errorMessage: '%errorMessage%',
                    eventType: '%eventType%',
                },
            },
            {
                providers: [GA4Provider],
                data: {
                    popupOrPageTitle: '%popupOrPageTitle%',
                    errorMessage: '%errorMessage%',
                },
            },
        ],
    },
    localisationViewPWA: {
        name: 'localisationViewPWA',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    viewSelected: '%viewSelected%',
                    orderType: '%orderType%',
                },
            },
        ],
    },
    viewOfferDetailsPwa: {
        name: 'viewOfferDetailsPwa',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    offerName: '%offerName%',
                },
            },
        ],
    },
    signInFinish: {
        name: 'signInFinish',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    userID: '%userID%',
                    loginMethod: '%loginMethod%',
                    firstName: '%firstName%',
                    lastName: '%lastName%',
                    phoneNumber: '%phoneNumber%',
                    emailAddress: '%emailAddress%',
                },
            },
            {
                providers: [GA4Provider],
                eventName: 'signInFinish',
                data: {
                    userID: '%userID%',
                    loginMethod: '%loginMethod%',
                },
            },
            {
                providers: [EnhancedBrazeProvider, MParticleProvider],
                data: {
                    loginMethod: '%loginMethod%',
                    eventType: '%eventType%',
                    userID: '%userID%',
                    emailId: '%emailId%',
                    phoneNumber: '%phoneNumber%',
                },
            },
            {
                providers: [BranchProvider],
                eventName: 'Login',
                data: {
                    userID: '%userID%',
                    loginMethod: '%loginMethod%',
                    eventParams: (eventName, params) => {
                        return {
                            alias: `${eventName}_FINISH | Account`,
                            customData: {
                                userID: params.userID,
                                loginMethod: params.loginMethod,
                            },
                        };
                    },
                },
            },
        ],
    },
    logSelectItem: {
        name: 'logSelectItem',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logSelectItem')])],
                data: {
                    item_list_id: '%item_list_id%',
                    item_list_name: CONST_ITEM_LIST_NAME,
                    content_type: '%content_type%',
                    items: '%items%',
                },
            },
            {
                providers: [provider(MParticle, [mParticleLogCommerceEventProduct])],
                data: {
                    currency: CONST_CURRENCY,
                    product_action_type: '%product_action_type%',
                    item_name: '%item_name%',
                    item_sku: '%item_id%',
                    value: '%value%',
                    item_quantity: '%quantity%',
                    item_category: '%item_category%',
                    item_list_name: CONST_ITEM_LIST_NAME,
                    revenue: '%revenue%',
                },
            },
        ],
    },
    logAddPaymentInfo: {
        name: 'logAddPaymentInfo',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logAddPaymentInfo')])],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    coupon: '%coupon%',
                    payment_type: '%payment_type%',
                    items: '%items%',
                },
            },
        ],
    },
    logAddShippingInfo: {
        name: 'logAddShippingInfo',
        payload: [
            {
                providers: [provider(GA4, [getGa4PredefinedFn('logAddShippingInfo')]), EnhancedBrazeProvider],
                data: {
                    currency: CONST_CURRENCY,
                    value: '%value%',
                    coupon: '%coupon%',
                    items: '%items%',
                },
            },
        ],
    },
    findAStore: {
        name: 'findAStore',
        payload: [
            {
                providers: [GA4Provider, EnhancedBrazeProvider],
            },
        ],
    },
    transactionFailed: {
        name: 'transactionFailed',
        payload: [
            {
                providers: [GTMProvider],
                data: {
                    event: '%event%',
                    errorMessage: '%errorMessage%',
                },
            },
        ],
    },
    trackOrder: {
        name: 'trackOrder',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
        ],
    },
    storeClose: {
        name: 'storeClose',
        payload: [
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                },
            },
            {
                providers: [GTMProvider],
            },
        ],
    },
    keepOrderSettings: {
        name: 'keepOrderSettings',
        payload: [
            {
                providers: [GTMProvider],
            },
            {
                providers: [MParticleProvider],
                data: {
                    eventType: '%eventType%',
                    keepOrder: '%keepOrder%',
                },
            },
        ],
    },
    selectRecommenededItem: {
        name: 'selectRecommenededItem',
        payload: [
            {
                providers: [GTMProvider],
            },
        ],
    },
    orderCompleted: {
        name: 'orderCompleted',
        payload: [
            {
                providers: [provider(FullStory, [fsLogOrderCompleted])],
                eventName: 'Order Completed',
                data: {
                    orderId_str: '%orderId_str%',
                    checkout_id: '%checkout_id%',
                    affiliation_str: '%affiliation_str%',
                    total_real: '%total_real%',
                    subtotal_real: '%subtotal_real%',
                    revenue_real: '%revenue_real%',
                    shipping_real: '%shipping_real%',
                    tax_real: '%tax_real%',
                    discount_real: '%discount_real%',
                    coupon_str: '%coupon_str%',
                    currency_str: '%currency_str%',
                    products: '%products%',
                },
            },
        ],
    },
    // new events for Japan.
    refineItems: {
        name: 'refineItems',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
                data: {
                    refineItems: '%refineItems%',
                },
            },
        ],
    },
    setAttributes: {
        name: 'setAttributes',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
                data: {
                    loggedIn: '%loggedIn%',
                },
            },
        ],
    },
    submittedVehicleDetails: {
        name: 'submittedVehicleDetails',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    viewMenu: {
        name: 'viewMenu',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    myPageView: {
        name: 'myPageView',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    acquireCouponButtonPress: {
        name: 'acquireCouponButtonPress',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    viewCouponDetail: {
        name: 'viewCouponDetail',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    useCouponForPickup: {
        name: 'useCouponForPickup',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    useCouponForDelivery: {
        name: 'useCouponForDelivery',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    useCouponForRestaurant: {
        name: 'useCouponForRestaurant',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    removeCouponFromCart: {
        name: 'removeCouponFromCart',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    chickenMileageDetailView: {
        name: 'chickenMileageDetailView',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    membershipCertificateView: {
        name: 'membershipCertificateView',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    kfcCardRegistrationSuccess: {
        name: 'kfcCardRegistrationSuccess',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    linkedPontaPoint: {
        name: 'linkedPontaPoint',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    linkedRakutenPoint: {
        name: 'linkedRakutenPoint',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    linkedLine: {
        name: 'linkedLine',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
    deliveryAggregatorClick: {
        name: 'deliveryAggregatorClick',
        payload: [
            {
                providers: [EnhancedBrazeProvider],
            },
        ],
    },
};
export default events;
